import React, { useState, useEffect } from 'react';
import { GridView, SimpleView } from '@digital/ui';
import { Collapse } from 'antd';
import {
  TipoPacote,
  getAllDisciplinas,
  getAllTipos,
  createDisciplina,
  createTipo,
  updateDisciplina,
  updateTipo,
  deleteDisciplina,
  deleteTipo,
} from '@app/api/tipoPacote';
import {
  AcronimoPacote,
  getAllAcronimosPacote,
  createAcronimoPacote,
  updateAcronimoPacote,
  deleteAcronimoPacote,
} from '@app/api/acronimosPacote';
import * as Yup from 'yup';
import TipoPacoteComponent from './ServicoPrazo';
import { getAllServicoPrazos, ServicoPrazo, updateServicoPrazo } from '@app/api/servicoPrazo';

const { Panel } = Collapse;


const ServicoPrazosComponent = () => {
  const [prazos, setPrazos] = useState<ServicoPrazo[]>();

  const fetchData = () => {
    const getTipos = async () => {
      const result = await getAllServicoPrazos();
      if (result) setPrazos(result);
    };

    getTipos();
  };

  useEffect(() => fetchData(), []);

  return (
    <SimpleView>
      <GridView noform>
        {true && (
          <>
            <TipoPacoteComponent
              titulo="Prazos"
              label="Nome do Tipo"
              data={prazos || []}
              handleUpdate={updateServicoPrazo}
              shouldUpdate={fetchData}
            />
          </>
        )}
      </GridView>
    </SimpleView>
  );
};

export default ServicoPrazosComponent;
